import { render, staticRenderFns } from "./manage-protocole.html?vue&type=template&id=4a7bf912&scoped=true&external"
import script from "./manage-protocole.js?vue&type=script&lang=js&external"
export * from "./manage-protocole.js?vue&type=script&lang=js&external"
import style0 from "./manage-protocole.scss?vue&type=style&index=0&id=4a7bf912&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7bf912",
  null
  
)

export default component.exports